export default __webpack_public_path__ + "static/media/icon.6ecadb81.svg";